import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Base from "./Base";
var Info = function Info(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Base, {
    type: "info"
  }, children);
};
Info.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};
export default /*#__PURE__*/memo(Info);